import React from "react";
import moment from "moment";
import PropTypes from "prop-types";
import { DateRangePicker } from "react-dates";
import PtoRequestStatusSelect from "../components/PtoRequestStatusSelect";
import UserSelect from "../../common/UserSelect";
import { validateAuthRoles } from "../../../helpers";

const PtoApprovalFilters = ({
  show,
  filters,
  handleSubmit,
  handleChange,
  loading,
  handleReset,
  auth,
  handleChangeDate,
  focusedInput,
  onFocusChange,
  onGetCallsClick
}) => {
  const classList = [
    "project-filters",
    "pto-filters",
    show ? "is-visible" : ""
  ].join(" ");

  return (
    <div className={classList}>
      <form className="report-filters" onSubmit={handleSubmit}>
        <PtoRequestStatusSelect
          isMulti
          value={filters?.status}
          defaultValues={[1]}
          onChange={handleChange("status")}
        />
        <UserSelect
          isMulti
          value={filters && filters.employee}
          onChange={handleChange("employee")}
          placeholder="Employee"
        />
        <UserSelect
          isMulti
          value={filters && filters.manager}
          disabled={!validateAuthRoles(auth, "Admin,HR")}
          onChange={handleChange("manager")}
          placeholder="Manager"
        />
        <DateRangePicker
          startDate={filters?.start_date ? moment(filters.start_date) : null}
          startDateId="startDate"
          endDate={filters?.end_date ? moment(filters.end_date) : null}
          endDateId="endDate"
          onDatesChange={({ startDate, endDate }) => {
            handleChangeDate(startDate, endDate);
          }}
          isOutsideRange={() => false}
          focusedInput={focusedInput}
          onFocusChange={onFocusChange}
        />
        <button
          disabled={loading}
          className="btn btn-info max-btn-height"
          type="button"
          onClick={onGetCallsClick}
        >
          Fetch Data
        </button>
        <button
          disabled={loading}
          className="btn btn-warning max-btn-height "
          type="button"
          onClick={handleReset}
        >
          Reset Filters
        </button>
      </form>
    </div>
  );
};

PtoApprovalFilters.propTypes = {
  show: PropTypes.bool,
  handleSubmit: PropTypes.func,
  handleChange: PropTypes.func,
  handleReset: PropTypes.func,
  loading: PropTypes.bool,
  filters: PropTypes.object,
  auth: PropTypes.object,
  handleChangeDate: PropTypes.func,
  focusedInput: PropTypes.node,
  onFocusChange: PropTypes.func,
  onGetCallsClick: PropTypes.func
};
export default PtoApprovalFilters;
